import React from "react";

const HorizontalRule = ({ customComponent, onClick, isActive, isDisabled }) => {
	const addHorizontalRule = () => {
		if (onClick) onClick();
	};

	return (
		<>
			<button
				className={`editor-menu-item${isActive ? " is-active" : ""}`}
				onClick={addHorizontalRule}
				title="Horizintal Rule"
				type="button"
				disabled={isDisabled}>
				{customComponent ? (
					customComponent
				) : (
					<i className="fas fa-grip-lines" />
				)}
			</button>
		</>
	);
};

export default HorizontalRule;
